import React from 'react';

interface SupportArticleFeedbackCheckboxListProps {
  questions: {
    id: string;
    question: string;
  }[];
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SupportArticleFeedbackCheckboxList = (
  props: Readonly<SupportArticleFeedbackCheckboxListProps>
) => {
  const questions = props.questions;
  return (
    <div>
      <ul
        className="questions-list"
        style={{ listStyle: 'none', columns: '2' }}
      >
        {questions.map(({ id, question }) => (
          <li key={id}>
            <div>
              <label
                style={{
                  textIndent: '-15px',
                }}
              >
                {' '}
                <input
                  style={{ marginRight: '5px' }}
                  type="checkbox"
                  id={`custom-checkbox-${id}`}
                  name={`question-${id}`}
                  value={id}
                  onChange={props.handleChange}
                />
                <span>{question}</span>
              </label>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SupportArticleFeedbackCheckboxList;
